import { mapGranularityKeyToLocalePrefix } from '../../utility/filters-helpers';

/**
 *
 * @example
 * ```
 * const options = Dropdown2
 *   .createOptionsFromGranularity(_)('age_groun_id', [1,2,3]);
 * ```
 */
export const createOptionsFromGranularity =
    (_: (key: string) => string) => (key: string, values?: (string | number)[]) => {
        return values == null
            ? values
            : values.map((i) => ({ value: i, label: _(mapGranularityKeyToLocalePrefix(key) + i) }));
    };
